import { SUMMARY_REPORT_OBJECT_TYPE } from "Common/dictionaries/summaryReportObjectType";
import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "addToSummaryReport";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
export const NEW_SUMMARY_REPORT_OBJECT = {
    Id: 0,
    Name: "",
    DocumentId: 0,
    SummaryReportObjectType: SUMMARY_REPORT_OBJECT_TYPE.GRAPH_SCREEN,
    Value: undefined
};
